var contentPreviewsAjax = false;

jQuery(document).ready(contentPreviewInit);

function contentPreviewInit(){
	
	var contentContainer = jQuery('#archive-content');
	var count = parseInt(contentContainer.attr('data-count'));
	var contentType = contentContainer.attr('data-content-type');
    
    jQuery('#load-more').on('click', function(){
		
		var loadMoreCount = parseInt(contentContainer.attr('data-load-more'));
		var taxonomy = contentContainer.attr('data-taxonomy');
		var term = contentContainer.attr('data-term');
		var offset = count + (count*loadMoreCount);
		var featured = contentContainer.attr('data-featured');
		
		get_content_previews(contentContainer, contentType, count, featured, taxonomy, term, offset);
		
		loadMoreCount++;
		
		contentContainer.attr('data-load-more', loadMoreCount);
		contentContainer.addClass('loading');
		
	});
	
	jQuery('select.filter').on('change', function(){
		
		var current = jQuery(this);
		var taxonomy = getFilterTerms(true);
		var term = getFilterTerms();
		var offset = 0;
		
		if(term) {
			contentContainer.attr('data-featured', 'both');
		} else {
			contentContainer.attr('data-featured', 'no');
		}
		
		var featured = contentContainer.attr('data-featured');
		
		get_content_previews(contentContainer, contentType, count, featured, taxonomy, term, offset);
		
		contentContainer.addClass('loading');
		contentContainer.attr('data-load-more', 0);
		contentContainer.attr('data-taxonomy', taxonomy);
		contentContainer.attr('data-term', term);
		
		if(term) {

			jQuery('div.filter-button-group a.active').removeClass('active');
			
			var terms = term.split(',');
			
			for(var i=0; i<terms.length; i++) {
				jQuery('div.filter-button-group a[data-term-id="' + terms[i] + '"]').addClass('active');	
			}
			
		} else {
			jQuery('div.filter-button-group a.active').removeClass('active');
			jQuery('div.filter-button-group a:first-child').addClass('active');
		}
		
		var url = window.location.href;
		url = updateUrlParameter(url, 'taxonomy', taxonomy);
		url = updateUrlParameter(url, 'terms', term);
		
		//window.history.pushState({}, '', url);
		
	});
	
	jQuery('a.button.filter').on('click', function(){
		
		var current = jQuery(this);
		var buttonTax = current.attr('data-tax');
		var buttonTerm = current.attr('data-term-id');

		current.siblings('.active').removeClass('active');
		current.addClass('active');
		
		if(buttonTerm) {
			jQuery('select.filter[data-tax="' + buttonTax + '"] option[value="' + buttonTerm + '"]').prop('selected', true);
			jQuery('select.filter[data-tax="' + buttonTax + '"]').addClass('active');
			contentContainer.attr('data-featured', 'both');
		} else {
			jQuery('select.filter[data-tax="' + buttonTax + '"]').prop('selectedIndex', 0).removeClass('active');
			contentContainer.attr('data-featured', 'no');
		}

		var taxonomy = getFilterTerms(true);
		var term = getFilterTerms();
		var offset = 0;
		var featured = contentContainer.attr('data-featured');
		
		get_content_previews(contentContainer, contentType, count, featured, taxonomy, term, offset);
		
		contentContainer.addClass('loading');
		contentContainer.attr('data-load-more', 0);
		contentContainer.attr('data-taxonomy', taxonomy);
		contentContainer.attr('data-term', term);
		
		var url = window.location.href;
		url = updateUrlParameter(url, 'taxonomy', taxonomy);
		url = updateUrlParameter(url, 'terms', term);
		
		//window.history.pushState({}, '', url);
		
	});
	
	jQuery(window).on('popstate', function(){
		location.reload();
	});
    
}

function get_content_previews(contentContainer, contentType, count = false, featured = 'no', taxonomy = false, term = false, offset = 0){
	
	if(contentPreviewsAjax) {
		return false;
	}
		
	contentPreviewsAjax = jQuery.ajax({
		url:"/wp-admin/admin-ajax.php",
		type:'POST',
		data:'action=get_content_previews_ajax&contentType=' + contentType + '&count=' + count + '&featured=' + featured + '&tax=' + taxonomy + '&term=' + term + '&offset=' + offset,
		success:function(results){
			
			if(offset) {
				contentContainer.append(results);
			} else {
				contentContainer.html(results);
			}
			
			if(taxonomy) {
				jQuery('#featured-container').hide();
			} else {
				jQuery('#featured-container').show();
			}
			
			contentContainer.removeClass('loading');
			contentPreviewsAjax = false;
			
		}
	});			

}

function getFilterTerms(returnTaxonomy = false) {
	
	var terms = [];
	var taxonomies = [];
	
	jQuery('select.filter').each(function(){
		
		const current = jQuery(this);
		const taxonomy = current.attr('data-tax');
		const term = current.val();
		
		if(term) {
			taxonomies.push(taxonomy);
			terms.push(term);
		}
		
	});
	
	if(returnTaxonomy) {
		return taxonomies.join();
	} else {
		return terms.join();
	}
}
